import { render } from "./TeamGroup.vue?vue&type=template&id=5555427b"
import script from "./TeamGroup.vue?vue&type=script&lang=js"
export * from "./TeamGroup.vue?vue&type=script&lang=js"
script.render = render

export default script